import ScalarIconWarning_vue_vue_type_script_setup_true_lang_default from "./ScalarIconWarning.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconWarning.vue
var ScalarIconWarning_default = ScalarIconWarning_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconWarning_default as default };

//# sourceMappingURL=ScalarIconWarning.js.map